'use client';

import React from 'react';

export default function MarqueeBanner() {
  const text =
    '★ DIGGITY GLOVER ★ METALCORE & DEATHCORE ★ SAMPLE PACKS, STEMS, MULTI-TRACKS & SHEET MUSIC AVAILABLE NOW ★ SESSION DRUMMING & MIX/MASTER SERVICES ★ BOOK NOW ★ DIGGITY GLOVER ★ METALCORE & DEATHCORE ★ SAMPLE PACKS, STEMS, MULTI-TRACKS & SHEET MUSIC AVAILABLE NOW ★ SESSION DRUMMING & MIX/MASTER SERVICES ★ BOOK NOW ★';

  return (
    <div
      style={{
        background: '#000000',
        borderTop: '1px solid #ff1a1a',
        borderBottom: '1px solid #ff1a1a',
        overflow: 'hidden',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        zIndex: 45,
      }}
    >
      <div
        className="animate-marquee"
        style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}
      >
        <span
          style={{
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '0.72rem',
            letterSpacing: '0.1em',
            color: '#ff1a1a',
            textTransform: 'uppercase',
            paddingRight: '60px',
          }}
        >
          {text}
        </span>
        <span
          style={{
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '0.72rem',
            letterSpacing: '0.1em',
            color: '#ff1a1a',
            textTransform: 'uppercase',
            paddingRight: '60px',
          }}
        >
          {text}
        </span>
      </div>
    </div>
  );
}
